/**
 * SearchTopLevelPlansApi
 * ──────────────────────
 * Fuzzy-searches top-level plans (no cascades/splits) by title,
 * scoped strictly to the performance cycle currently loaded by the user.
 *
 * @param {string} query              - partial plan title from natural language
 * @param {string} performanceCycleId - currently loaded cycle ID
 * @param {string} [positionId]       - optional: restrict to a specific position
 * @returns {Promise<{ success, data, message }>}
 */
export default async function SearchTopLevelPlansApi(query, performanceCycleId, positionId) {
  try {
    const token = 'Bearer ' + localStorage.getItem('authToken');
    const params = new URLSearchParams({ query, performanceCycleId });
    if (positionId) params.append('positionId', positionId);

    const res = await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/search?${params.toString()}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
          Authorization: token,
        },
      }
    );
    return await res.json();
  } catch (err) {
    console.error('[SearchTopLevelPlansApi] error:', err);
    return { success: false, data: [], message: 'Request failed' };
  }
}
